export interface NewsItem {
  readonly id: string
  readonly title: string
  readonly date: string
  readonly excerpt: string
  readonly link: string
  readonly image: string
  readonly mobileImage: string
  readonly imageAlt: string
}

export const newsData: readonly NewsItem[] = [
  /*{
    id: 'placeholder-1',
    title: 'Placeholder Title',
    date: 'January 1st, 2000',
    excerpt:
      "placeholder text",
    link: 'www.placeholder.com/',
    image: 'https://picsum.photos/600/600',
    mobileImage:
      'https://picsum.photos/800/600',
    imageAlt: 'Place holder image',
  },*/
] as const
